module.exports = __webpack_public_path__ + "gfx/WLS-15-01.png";